module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "videoPlayer"
  }, [(!_vm.playerReady) ? _c('div', {
    staticClass: "loading-container vjs-waiting",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "vjs-loading-spinner",
    attrs: {
      "dir": "ltr"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerReady),
      expression: "playerReady"
    }],
    staticClass: "videojs-player",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": _vm.playerElement
    },
    on: {
      "seeked": _vm.seekedEvent,
      "timeupdate": _vm.timeUpdateEvent,
      "playing": _vm.playingEvent,
      "pause": _vm.pauseEvent,
      "ended": _vm.endedEvent
    }
  }, [(_vm.record.url) ? _c('source', {
    attrs: {
      "src": _vm.record.url,
      "type": _vm.record.mimetype
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d4b931"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordPlayer.vue
// module id = 1048
// module chunks = 1